<div class="panel" #panel>
  <ng-content> </ng-content>
</div>
